import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import StoreServiceListSection from "./store-services-list-section";
import { ITreatmentWithOptionVM } from "../../../../models/response/IStoreCmsResponse";
import { Row } from "react-bootstrap";

interface IProps {
  treatmentList: ITreatmentWithOptionVM[];
  storeDetails: any; // Adjust type as needed
  storeCode: string;
}

const StoreServicesTab: React.FC<IProps> = (props) => {
  return (
    <>
      <h1 className="fw-normal">
        {props.storeDetails?.StoreName}
      </h1>
      <Row>
        {props.treatmentList.length === 0 ? (
          <p className="text-muted">
            <FormattedMessage id="no_services_available" />
          </p>
        ) : (
          props.treatmentList.map((treatment, index) => (
            <StoreServiceListSection key={index} treatment={treatment} store={props.storeDetails} storeCode={props.storeCode} />
          ))
        )}
      </Row>
    </>
  );
};

export default StoreServicesTab;
